import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
var DefaultRenderButton = function DefaultRenderButton(_ref) {
  var disabled = _ref.disabled,
    type = _ref.type;
  return jsx("button", {
    disabled: disabled,
    type: type,
    children: "Place order and pay"
  });
};
var StripePaymentButton = function StripePaymentButton(_ref2) {
  var _ref2$isDisabled = _ref2.isDisabled,
    isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
    renderPaymentButton = _ref2.renderPaymentButton;
  var buttonRenderer = useMemo(function () {
    return renderPaymentButton !== null && renderPaymentButton !== void 0 ? renderPaymentButton : DefaultRenderButton;
  }, [renderPaymentButton]);
  return buttonRenderer({
    disabled: isDisabled,
    type: 'submit'
  });
};
export { StripePaymentButton as default };